import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faHourglassHalf,
  faCoins,
  faCreditCard,
} from '@fortawesome/free-solid-svg-icons';

import { IUserWalletReward } from '@share/common-types';
import { renderNumber } from '@share/utils';

import { Currency } from '../../common/currency';

import './style.scss';

interface IProps {
  wallet: IUserWalletReward | null | undefined;
}

function formatInteger(val: number | undefined): string {
  return val != null ? Math.floor(Number(val)).toLocaleString('en-US') : '—';
}

export function RewardsSummary(props: IProps) {
  const { wallet } = props;

  return (
    <div className="rewards-summary">
      <div className="rewards-summary__box rewards-summary__box--accumulated">
        <FontAwesomeIcon icon={faChartLine} className="rewards-summary__icon" />
        <div className="rewards-summary__content">
          <span className="rewards-summary__label">
            <FormattedMessage id="rewards.summary.yourProgress" />
          </span>
          <span className="rewards-summary__value">{formatInteger(wallet?.accumulatedProgress)}</span>
        </div>
      </div>
      <div className="rewards-summary__box rewards-summary__box--pending">
        <FontAwesomeIcon icon={faHourglassHalf} className="rewards-summary__icon" />
        <div className="rewards-summary__content">
          <span className="rewards-summary__label">
            <FormattedMessage id="rewards.summary.onItsWay" />
          </span>
          <span className="rewards-summary__value">{formatInteger(wallet?.pendingProgress)}</span>
        </div>
      </div>
      <div className="rewards-summary__box rewards-summary__box--available">
        <FontAwesomeIcon icon={faCoins} className="rewards-summary__icon" />
        <div className="rewards-summary__content">
          <span className="rewards-summary__label">
            <FormattedMessage id="rewards.summary.readyForGetaway" />
          </span>
          <span className="rewards-summary__value">{formatInteger(wallet?.totalAvailableRewards)}</span>
        </div>
      </div>
    </div>
  );
}
